import {
  AiOutlineFileDone,
  AiOutlineHourglass,
  AiOutlineLock,
} from 'react-icons/ai';
import {
  FiCalendar,
  FiEdit,
  FiFilePlus,
  FiFileText,
  FiHome,
  FiSearch,
  FiTool,
  FiUpload,
} from 'react-icons/fi';

import { colors } from '@brand/theme/foundations';
import { EInterventionStatus, EInterventionType } from 'models/Intervention';
import { IInterventionTimeline } from 'models/InterventionDetails';

import pages from 'constants/pages';

import interventionTypes from './interventionTypes';

export const timelineTraderActions: IInterventionTimeline[] = [
  {
    value: EInterventionStatus.DateInspectionRequired,
    leftIcon: FiCalendar,
    rightIcon: FiEdit,
    page: (id: number) => pages.intervention.planning(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnQuote.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.LeakDetectionDateRequired,
    leftIcon: FiCalendar,
    rightIcon: FiEdit,
    page: (id: number) => pages.intervention.planning(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnLeakDetection.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.InspectionPlanned,
    leftIcon: FiHome,
    rightIcon: FiEdit,
    page: (id: number) => pages.intervention.planning(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnQuote.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.LeakDetectionPlanned,
    leftIcon: FiSearch,
    rightIcon: FiEdit,
    page: (id: number) => pages.intervention.planning(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnLeakDetection.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.WaitingForQuote,
    leftIcon: FiFileText,
    rightIcon: FiUpload,
    page: (id: number) => pages.intervention.documents(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnQuote.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.QuoteEvaluation,
    leftIcon: FiFileText,
    rightIcon: AiOutlineHourglass,
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnQuote.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.DateRepairInterventionRequired,
    leftIcon: FiCalendar,
    rightIcon: FiEdit,
    page: (id: number) => pages.intervention.planning(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnQuote.includes(type) ||
      interventionTypes.typesBasedOnUrgentOrCostPlus.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.RepairInterventionPlanned,
    leftIcon: FiTool,
    rightIcon: FiEdit,
    page: (id: number) => pages.intervention.planning(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.typesBasedOnQuote.includes(type) ||
      interventionTypes.typesBasedOnUrgentOrCostPlus.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.WaitingForInvoice,
    leftIcon: FiFilePlus,
    rightIcon: FiUpload,
    page: (id: number) => pages.intervention.documents(id),
    interventionType: (type: EInterventionType) =>
      interventionTypes.allTypes.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },
  {
    value: EInterventionStatus.ProcessInvoice,
    leftIcon: FiFileText,
    rightIcon: AiOutlineHourglass,
    interventionType: (type: EInterventionType) =>
      interventionTypes.allTypes.includes(type),
    dynamicItems: {
      date: '/',
      color: colors.gray[300],
      icon: AiOutlineLock,
      measure: 6,
    },
  },

  {
    value: EInterventionStatus.Paid,
    leftIcon: AiOutlineFileDone,
    interventionType: (type: EInterventionType) =>
      interventionTypes.allTypes.includes(type),
    dynamicItems: {
      date: '/',
      color: 'var(--rik-intervention-paid)',
      icon: AiOutlineLock,
      measure: 6,
    },
  },
];
